import type { Locale } from '@change-corgi/config/locales';

import type { INTL_LOCALE_CHECKS } from './intlLocale';
import type { INTL_NUMBER_FORMAT_CHECKS } from './intlNumberFormat';
import type { INTL_PLURAL_RULES_CHECKS } from './intlPluralRules';
import type { INTL_RELATIVE_TIME_FORMAT_CHECKS } from './intlRelativeTimeFormat';

export async function setupIntl(_: { locale: Locale }): Promise<void> {
	return Promise.resolve();
}

type IntlName =
	| (typeof INTL_LOCALE_CHECKS)[0]['name']
	| (typeof INTL_NUMBER_FORMAT_CHECKS)[0]['name']
	| (typeof INTL_PLURAL_RULES_CHECKS)[0]['name']
	| (typeof INTL_RELATIVE_TIME_FORMAT_CHECKS)[0]['name'];

export function checkIntlFeatures(_locale: string): Readonly<Record<IntlName, boolean>> {
	return {
		locale: true,
		'number-format': true,
		'plural-rules': true,
		'relative-time-format': true,
	};
}
